export default __webpack_public_path__ + "static/media/icon_category.4f5d23f0.svg";